/**
 * Created by Daniel Wang on 3/3/2024.
 * Description: the effects for admin general page
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { AdminPagesService } from '../../../tamalelibs/services/admin-page.service';
import { AdminPageActionTypes } from '../../actions/admin-page.actions';
import { ConfigureHTMLSecurity, FMROverrides, GeneralGridType, StopList } from '../../../tamalelibs/models/admin-page.model';

@Injectable()
export class AdminGeneralPageEffects {
    constructor(
        private _actions$: Actions,
        private _adminPageService: AdminPagesService
    ) { }

    getGeneralPageEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.GET_GENERAL_PAGE),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => {
            return this._adminPageService.getGeneralData(payload.type).pipe(
                map(response => {
                    if (response) {
                        const dataList = this._adminPageService.getParseGeneralData(response, payload.type);
                        return {
                            type: AdminPageActionTypes.GET_GENERAL_PAGE_SUCCESS,
                            payload: dataList
                        };
                    }
                })
            );
        }),
        catchError(err => {
            return of({
                type: AdminPageActionTypes.GET_GENERAL_PAGE_FAILURE,
                payload: err.message
            });
        })
    ));

    createGeneralPageEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.CREATE_GENERAL_PAGE),
        map((action: any) => action.payload),
        switchMap((payload) => {
            return this._adminPageService.createGeneralData(payload.type, payload.item).pipe(
                map(response => {
                    let data = response;
                    if (payload.type === GeneralGridType.FMROverrides) {
                        data = FMROverrides.parse(response);
                    } else if (payload.type === GeneralGridType.StopList) {
                        data = StopList.parse(response);
                    } else if (payload.type === GeneralGridType.ConfigureHTMLSecurity) {
                        const configureHTML = new ConfigureHTMLSecurity();
                        configureHTML.tag = payload.item.toLowerCase();
                        data = configureHTML;
                    }
                    return {
                        type: AdminPageActionTypes.CREATE_GENERAL_PAGE_SUCCESS,
                        payload: {
                            type: payload.type,
                            data: data
                        }
                    };
                }),
                catchError(err => {
                    return of({
                        type: AdminPageActionTypes.CREATE_GENERAL_PAGE_FAILURE,
                        payload: err.message
                    });
                })
            );
        })
    ));

    editGeneralPageEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.EDIT_GENERAL_PAGE),
        map((action: any) => action.payload),
        switchMap((payload) => {
            return this._adminPageService.editGeneralData(payload.type, payload.item, payload.oldItem).pipe(
                map(response => {
                    let data = response;
                    let oldData = response;
                    if (payload.type === GeneralGridType.ConfigureHTMLSecurity) {
                        const configureHTML = new ConfigureHTMLSecurity();
                        configureHTML.tag = payload.item.tag.toLowerCase();
                        data = configureHTML;

                        const oldConfigureHTML = new ConfigureHTMLSecurity();
                        oldConfigureHTML.tag = payload.oldItem.tag.toLowerCase();
                        oldData = oldConfigureHTML;
                    }
                    return {
                        type: AdminPageActionTypes.EDIT_GENERAL_PAGE_SUCCESS,
                        payload: {
                            type: payload.type,
                            data: data,
                            oldData: oldData
                        }
                    };
                })
            );
        }),
        catchError(err => {
            return of({
                type: AdminPageActionTypes.EDIT_GENERAL_PAGE_FAILURE,
                payload: err.message
            });
        })
    ));

    deleteGeneralPageEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.DELETE_GENERAL_PAGE),
        map((action: any) => action.payload),
        switchMap((payload) => {
            return this._adminPageService.deleteGeneralData(payload.type, payload.id, payload.name).pipe(
                map((response) => {
                    let data = response;
                    if (payload.type === GeneralGridType.ConfigureHTMLSecurity) {
                        const configureHTML = new ConfigureHTMLSecurity();
                        configureHTML.tag = payload.name.toLowerCase();
                        data = configureHTML;
                    }
                    return {
                        type: AdminPageActionTypes.DELETE_GENERAL_PAGE_SUCCESS,
                        payload: {
                            type: payload.type,
                            data: data
                        }
                    };
                })
            );
        }),
        catchError(err => {
            return of({
                type: AdminPageActionTypes.DELETE_GENERAL_PAGE_FAILURE,
                payload: err.message
            });
        })
    ));
}
